export default __webpack_public_path__ + "static/media/Foundations_8x2.256.8b04357e.png";